import ResponsiveImage from 'components/core/ResponsiveImage'
import Markdown from 'markdown-to-jsx'
import { GridSectionData } from 'types/generatedTypes'
import { GetThemeClasses } from 'utils/GetThemeClasses'

interface Grid {
  data: GridSectionData
}
export default function GridSection({ data }: Grid) {
  return (
    <section
      className={`py-28 ${data?.theme && GetThemeClasses(data?.theme)} ${
        data?.styleClassNames
      }`}
    >
      <div className="container !max-w-[600px]">
        <h2 className="text-center text-[32px]">{data?.title}</h2>
      </div>
      <div className="container lg:grid grid-flow-row grid-cols-2 gap-8">
        {data?.textBlocks &&
          data?.textBlocks.map((feature, index) => {
            return (
              <div key={feature.title} className="flex flex-col pt-10">
                <div className="py-2">
                  <ResponsiveImage
                    extraClassNames="h-14 w-16"
                    data={feature.image}
                  />
                </div>
                <div className="text-[20px]">
                  <h3>{feature.title}</h3>
                </div>
                <div className="text-lg text-[#6B6B6B]">
                  <Markdown>{feature.content ?? ''}</Markdown>
                </div>
              </div>
            )
          })}
      </div>
    </section>
  )
}
